import React from "react";
import { useTranslation } from "react-i18next";

export default function AltAccountSecondaryNotice() {
  const { t } = useTranslation();

  return (
    <div
      className="alt-account-secondary-notice"
      role="status"
      aria-live="polite"
    >
      <span className="alt-account-secondary-notice__icon" aria-hidden="true">
        ⚠
      </span>
      <span className="alt-account-secondary-notice__text">
        {t("altAccountWarningMessage")}
      </span>
    </div>
  );
}
